import { grey, orange, red } from '@mui/material/colors';

export default {
  common: {
    white: '#fff',
    black: '#000',
  },
  primary: {
    light: '#f9bb47',
    main: '#f7a707',
    dark: '#c58400',
    contrastText: '#fff',
  },
  error: {
    light: red.A200,
    main: red[400],
    dark: red[900],
    contrastText: '#fff',
  },
  text: {
    primary: grey[900],
    secondary: grey[600],
  },
  background: {
    default: '#fff',
    paper: grey[100],
  },
  icon: grey[600],
  divider: grey[200],
  input: {
    borderColor: grey[300],
  },
  tabs: {
    borderColor: grey[200],
  },
  list: {
    selected: grey[200],
  },
  avatar: {
    background: orange.A200,
  },
};
